import React from 'react';
import './Process.css';
import ProcessItem from "../ProcessItem/ProcessItem";

let process = [
    {
        title: <>погружаемся<br/>в проект</>,
        text: <>Мы внимательно изучаем ваш<br/>бриф, определяем цели<br/>
            и задачи, создаем медиаплан,<br/>который точно направлен<br/>
            на ключевые каналы и нужные<br/>метрики.</>
    },
    {
        title: <>создаем<br/>материалы</>,
        text: <>Разрабатываем креативные<br/>материалы, которые цепляют,<br/>
            и тщательно подготавливаем<br/>блогеров для успешного старта<br/>кампании.</>
    },
    {
        title: <>запускаем и<br/>контролируем</>,
        text: <>Запускаем и контролируем<br/>вашу рекламную кампанию<br/>
            с ювелирной точностью,<br/>ежедневно оптимизируя её<br/>для достижения<br/>максимального результата.</>
    },
    {
        title: <>предоставляем<br/>аналитику</>,
        text: <>Предоставляем полный отчет<br/>по кампании<br/>
            с детализированной<br/>аналитикой и стратегическими<br/>рекомендациями<br/>
            для дальнейшего роста вашего<br/>бренда.</>
    },
]

export default function Process() {
    return <div className="process">
        {process.map((p, index) => <ProcessItem {...p} prefix={"/0"+(index+1)}/>)}
    </div>
}
